import { useTheme } from "styled-components";
import { RuntimeTheme } from "webapp/lib/theme/theme";

export function useRuntimeTheme() {
    return useTheme() as RuntimeTheme;
}
